import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import ProfileInvoiceDetailsSectionView from './ProfileInvoiceDetailsSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './ProfileInvoiceDetailsSectionView';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (): $DispatchProps => Object.freeze({
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileInvoiceDetailsSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
